import React, { FC, useState } from 'react';

import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { LoginModal } from 'components';
import { ROUTES } from 'core';
import { selectIsUserReLoginRequired, selectUser } from 'store/user/userSlice';
import { useAppSelector } from 'store';

import { Divider } from '@britishcouncil/react-solas-ors3';
import { Button } from '@britishcouncil/react-solas';

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
`;
const ButtonsHeader = styled('h4')`
  font-weight: 600;
  font-size: 0.9em;
`;

const BasketButtons: FC<{ showRegisterBtn: boolean }> = ({ showRegisterBtn }) => {
  const navigate = useNavigate();
  const loggedUser = useAppSelector(selectUser);
  const isUserReLoginRequired = useAppSelector(selectIsUserReLoginRequired);
  const [showModal, setShowModal] = useState(false);

  const onRegisterBtnClick = () => {
    if (!loggedUser || isUserReLoginRequired) {
      setShowModal(true);
    } else {
      navigate(ROUTES.TEST_TAKER_DETAILS);
    }
  };

  return (
    <>
      <Divider />
      {showRegisterBtn && <ButtonsHeader>Choose an action below</ButtonsHeader>}
      <ButtonsContainer>
        {showRegisterBtn && (
          <>
            <Button intent={'primary'} onClick={onRegisterBtnClick}>
              Register and pay now
            </Button>
            <span>or</span>
          </>
        )}
        <Button onClick={() => navigate(ROUTES.EXAMS)}>Add another exam</Button>
      </ButtonsContainer>
      <LoginModal show={showModal} onExit={() => setShowModal(false)} />
    </>
  );
};

export default BasketButtons;
